import { Outlet } from "react-router-dom";
import { PageContainer, Wrapper } from "./styles";
import { SideNavProvider } from "@/providers/SideNav";
import { Center, Spinner } from "@chakra-ui/react";
import { Suspense } from "react";
import { SideNav } from "../SideNav";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "react-router-dom";
import HeaderInfoUser from "./HeaderInfoUser";

function RouteFallback() {
  return (
    <Center h="100%" w="100%">
      <Spinner size="xl" color="#117baa" thickness="3px" />
    </Center>
  );
}

export function Layout() {
  const { user } = useAuth();

  return (
    <SideNavProvider>
      <>
        <HeaderInfoUser Link={Link} user={user} />
        <Wrapper>
          <SideNav />
          <Page />
        </Wrapper>
      </>
    </SideNavProvider>
  );
}

function Page() {
  return (
    <PageContainer
      animate={{
        overflowX: "hidden",
        height: "calc(100vh)",
        background: "#e9ecef",
      }}
    >
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </PageContainer>
  );
}